import React from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'



const EbayLinkDeletorModal = ({
  ebay,
  showEbayLinkDeletorModal,
  onSuccess,
  onDiscard,
}) => {

  return <Modal animation={false} centered size="lg"
     show={showEbayLinkDeletorModal}
     onHide={onDiscard}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {I18n.t('js.indexSaleItems.ebayLink.ebayLinkRemotion.title').replaceAll(':sale_channel', ebay.meta_name)}
        </Modal.Title>
      </Modal.Header>
    <Modal.Body>
      {
        [1, 2, 3, 4].map(index => {
          return <p key={index}>
            {I18n.t(`js.indexSaleItems.ebayLink.ebayLinkRemotion.p_${index}`).replaceAll(':sale_channel', ebay.meta_name)}
          </p>
        })
      }

      <div className="d-flex justify-content-between w-100 mx-0 mt-4">
        <div>
          <button
            type="button"
            className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
            onClick={onDiscard}
          >
            {I18n.t('js.common.cancel').toUpperCase()}
          </button>
        </div>

        <div>
          <button
            className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
            onClick={onSuccess}
          >
            {I18n.t('js.indexSaleItems.ebayLink.removeYour').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
          </button>
        </div>
      </div>
    </Modal.Body>
  </Modal>
};

export default EbayLinkDeletorModal;